'use client';

import Image from 'next/image';
import Link from 'next/link';
import { getLayoutContent } from "@/lib/storyblok";
import ApplicationLayout from "@/components/layouts/Application";
import "@/assets/stylesheets/application.scss";
import { useEffect, useState } from 'react';

interface ErrorProps {
  error: Error;
}

const ErrorContent = () => (
  <div className="container text-center my-5 py-5">
    <div className="d-flex w-100 align-items-center justify-content-center  my-5">
      <div>
        <Link href="/">
          <Image
            src="/logo-dark.svg"
            width={120}
            height={64}
            alt="Target Defense"
            priority
          />
        </Link>
        <h1 className="text-black mt-4">500: Server Error</h1>
        <h2 className="text-primary mb-4">Sorry, something went wrong on our end</h2>
        <p>We&apos;re experiencing technical difficulties.</p>
        <p className="mb-4">Choose a link below to get to back to homepage.</p>
        <div className="buttons">
          <Link href="/" className="btn btn-primary me-2">
            Return to Homepage
          </Link>
          <Link href="/contact" className="btn btn-outline-dark">
            Contact
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default function Error({ error }: ErrorProps) {
  const [layoutContent, setLayoutContent] = useState<any>(null);
  const [layoutError, setLayoutError] = useState(false);

  useEffect(() => {
    console.error('Application error:', error);

    const loadLayout = async () => {
      try {
        const content = await getLayoutContent();
        setLayoutContent(content);
      } catch (e) {
        console.error('Failed to load layout:', e);
        setLayoutError(true);
      }
    };

    loadLayout();
  }, [error]);

  if (layoutError || !layoutContent) {
    return <ErrorContent />;
  }

  const { headerBlock, footerBlock, stickyNavBlock } = layoutContent;

  return (
    <ApplicationLayout
      styleController="page-500"
      header={headerBlock}
      footer={footerBlock}
      stickynav={stickyNavBlock}
    >
      <ErrorContent />
    </ApplicationLayout>
  );
}